import { useNavigate, useParams } from 'react-router-dom';
import useExamHierarchy from '../hooks/useExamHierarchy';
import useExamDetail from '../hooks/useExamDetail';
import ExamPageHeader from '../components/exam/ExamPageHeader';
import ExamStructureTree from '../components/exam/ExamStructureTree';
import { Card, PageSkeleton, ErrorState } from '../components/ui';

// Structure-first view of an enrolled exam: what's inside it (sections,
// topics, question distribution). Question-level browsing lives in the
// question bank — every topic deep-links there.
export default function ExamDetailsPage() {
  const { examId } = useParams();
  const navigate = useNavigate();
  const exam = useExamDetail(examId);
  const { sections, countsByTopic, totalQuestions, topicCount, loading, error } = useExamHierarchy(examId);

  if (loading) return <PageSkeleton />;
  if (error) return <ErrorState message={error} />;

  return (
    <>
      <ExamPageHeader
        examId={examId}
        active="structure"
        title={exam?.title || exam?.name || 'Exam structure'}
        description={exam?.description || 'Sections, topics and question distribution for this exam.'}
        stats={{ sections: sections.length, topics: topicCount, questions: totalQuestions }}
      />
      <Card className="table-card structure-card">
        <ExamStructureTree
          sections={sections}
          countsByTopic={countsByTopic}
          onBrowseTopic={(topic) => navigate(`/question-banks/${examId}?topic=${topic.id}`)}
        />
      </Card>
    </>
  );
}
